import { apiFetch } from './client';

/** One row of a service's guide index. */
export interface GuideSummary {
  /** URL segment under /apis/{apiId}/guides/. */
  id: string;
  title: string;
  /** One line; may be empty. */
  summary: string;
}

export interface GuideIndex {
  apiId: string;
  /** The service's own name for itself, from the bundle. */
  displayName: string;
  /** When the bundle was last synced. */
  updatedAt: string;
  /** In reading order. Empty means the service publishes no guides. */
  guides: GuideSummary[];
}

export interface GuideDocument {
  apiId: string;
  displayName: string;
  updatedAt: string;
  guide: GuideSummary & {
    /** Markdown; body headings start at `##`. */
    body: string;
  };
}

/**
 * A service's guides: prose for integrators, authored in the service's own
 * repository and pulled on a schedule (docs/service-guides.md). Both routes are
 * public and unversioned — a guide describes the service as deployed now.
 *
 * A service that has published no bundle answers 404; the query layer turns
 * that into an empty index, since the section is optional by design.
 */
export const listGuides = (apiId: string) =>
  apiFetch<GuideIndex>(`/api/v1/apis/${encodeURIComponent(apiId)}/guides`);

export const getGuide = (apiId: string, guideId: string) =>
  apiFetch<GuideDocument>(
    `/api/v1/apis/${encodeURIComponent(apiId)}/guides/${encodeURIComponent(guideId)}`,
  );
